import { DroneEntity } from './drone-entity';
import { DroneStatusType, formatDroneStatusLabel } from './drone-status-type';

/**
 * Status label shown for a drone in the UI.
 *
 * An OTA "update required" verdict (axis B — `ota.updateRequired`) is surfaced as the
 * UPDATE REQUIRED status regardless of the drone's operational status (axis A — `status`):
 * a blocking firmware need is what the operator must act on, so an OFFLINE / NOT_ACTIVE drone
 * that requires firmware still reads UPDATE REQUIRED. Falls back to the operational status label.
 *
 * Note: this only affects the displayed label, never the operational grouping/selection.
 */
export const formatDroneDisplayStatus = (drone: DroneEntity): string =>
  drone.ota?.updateRequired
    ? formatDroneStatusLabel(DroneStatusType.UPDATE_SOFTWARE_REQUIRED)
    : formatDroneStatusLabel(drone.status);
